import React from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Avatar,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Grid,
  GridItem,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";

export default function UserDetail() {
  const { id } = useParams();

  // Dummy user - replace with API
  const user = {
    id,
    name: "Rohan Roy",
    email: "rohan.roy@email.com",
    role: "Sales",
    zone: "West Zone",
    status: "Active",
    dob: "12 June 1990",
    gender: "Male",
    language: "English, Hindi",
    state: "Maharashtra",
    city: "Mumbai",
    pincode: "411032",
    address: "203, Shanti Sadan, Andheri East, Mumbai",
    mobile: "+91 8822562512",
    whatsapp: "+91 8822562512",
  };

  return (
    <Box w="100%" bg="#F5F7FA" p={6}>
      {/* Breadcrumb */}
      <BreadCrumbMaker
        items={[
          { title: "Access Control", link: "/settings" },
          { title: "Manage User", link: "/settings/user/manage" },
          { title: "View User", link: `/settings/user/${id}`, on: true },
        ]}
      />

      {/* USER HEADER */}
      <Box
        bg="white"
        borderRadius="16px"
        p={6}
        mt={4}
        border="1px solid #E5E7EB"
      >
        <Flex justify="space-between" align="center">
          <Flex align="center" gap={4}>
            <Avatar
              size="xl"
              src="https://images.unsplash.com/photo-1502685104226-ee32379fefbe"
            />
            <Box>
              <Text fontSize="2xl" fontWeight="700">
                {user.name}
              </Text>
              <Text>User ID: rohan@prm</Text>

              <Flex gap={3} mt={2}>
                <Text bg="#F0F4FF" px={3} py={1} borderRadius="8px">
                  {user.role}
                </Text>
                <Text bg="#F0F4FF" px={3} py={1} borderRadius="8px">
                  {user.zone}
                </Text>
                <Text bg="#C6F6D5" px={3} py={1} borderRadius="8px">
                  {user.status}
                </Text>
              </Flex>
            </Box>
          </Flex>

          <Flex gap={3}>
            <Button bg="#4C7CF7" color="white" _hover={{ bg: "#3b6ae0" }}>
              Edit Profile
            </Button>
            <Button bg="white" border="1px solid #D0D5DD">
              Reset Password
            </Button>
          </Flex>
        </Flex>

        {/* TABS */}
        <Tabs mt={6} variant="unstyled">
          <TabList
            bg="#EEF2FF"
            p={2}
            borderRadius="12px"
            display="inline-flex"
            gap={2}
          >
            {[
              "User Details",
              "Employment Details",
              "Emergency Contact",
              "Documents",
            ].map((tab) => (
              <Tab
                key={tab}
                px={5}
                py={2}
                borderRadius="10px"
                fontWeight="600"
                color="#4A5568"
                _selected={{
                  bg: "white",
                  color: "#2D3748",
                  boxShadow: "sm",
                }}
                _hover={{
                  bg: "whiteAlpha.700",
                }}
              >
                {tab}
              </Tab>
            ))}
          </TabList>

          <TabPanels mt={6}>
            {/* USER DETAILS */}
            <TabPanel p={0}>
              <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                <GridItem>
                  <Text fontWeight="600">Full Name</Text>
                  <Text>{user.name}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Email ID</Text>
                  <Text>{user.email}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Mobile Number</Text>
                  <Text>{user.mobile}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Date of Birth</Text>
                  <Text>{user.dob}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Gender</Text>
                  <Text>{user.gender}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Language</Text>
                  <Text>{user.language}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">State</Text>
                  <Text>{user.state}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">City</Text>
                  <Text>{user.city}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Pincode</Text>
                  <Text>{user.pincode}</Text>
                </GridItem>

                <GridItem colSpan={3}>
                  <Text fontWeight="600">Address</Text>
                  <Text>{user.address}</Text>
                </GridItem>
              </Grid>
            </TabPanel>

            {/* EMPLOYMENT DETAILS */}
            <TabPanel p={0}>
              <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                <GridItem>
                  <Text fontWeight="600">Employee ID</Text>
                  <Text>EMP-00{id}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Department</Text>
                  <Text>{user.role}</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Designation</Text>
                  <Text>Senior Sales Executive</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Joining Date</Text>
                  <Text>01 Jan 2021</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Work Location</Text>
                  <Text>
                    {user.city}, {user.state}
                  </Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Employment Status</Text>
                  <Text>{user.status}</Text>
                </GridItem>

                <GridItem colSpan={3}>
                  <Text fontWeight="600">Work Description</Text>
                  <Text>
                    Responsible for managing leads, converting clients, and
                    handling regional travel bookings.
                  </Text>
                </GridItem>
              </Grid>
            </TabPanel>

            {/* EMERGENCY CONTACT */}
            <TabPanel p={0}>
              <Grid templateColumns="repeat(3, 1fr)" gap={6}>
                <GridItem>
                  <Text fontWeight="600">Contact Person Name</Text>
                  <Text>Ritesh Roy</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Relationship</Text>
                  <Text>Brother</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Mobile Number</Text>
                  <Text>+91 9876543210</Text>
                </GridItem>

                <GridItem>
                  <Text fontWeight="600">Alternate Number</Text>
                  <Text>+91 9988776655</Text>
                </GridItem>

                <GridItem colSpan={3}>
                  <Text fontWeight="600">Address</Text>
                  <Text>Andheri West, Mumbai, Maharashtra</Text>
                </GridItem>
              </Grid>
            </TabPanel>

            {/* DOCUMENTS */}
            <TabPanel p={0}>
              <Text fontSize="lg" fontWeight="600" mb={3}>
                Address Proof
              </Text>

              <Flex gap={5} flexWrap="wrap">
                {[
                  "Adhar Card Front Image",
                  "Adhar Card Back Image",
                  "Pancard Image",
                ].map((title, i) => (
                  <Box
                    key={i}
                    w="260px"
                    bg="white"
                    p={4}
                    borderRadius="12px"
                    border="1px solid #E5E7EB"
                    boxShadow="sm"
                  >
                    <Flex justify="space-between" align="center">
                      <Text fontWeight="600" fontSize="sm">
                        {title}
                      </Text>
                      <Box
                        bg="#F5F6FA"
                        p="6px"
                        borderRadius="50%"
                        cursor="pointer"
                      >
                        👁️
                      </Box>
                    </Flex>
                    <Text fontSize="xs" mt={2}>
                      {title.replaceAll(" ", "_")}.jpg
                    </Text>
                  </Box>
                ))}
              </Flex>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
}
